module.exports = __webpack_public_path__ + "img/covid19.5280456a.jpg";